import { UploadedFileApi } from '../generated-api';
import { API_CONFIG } from '../app/api-config';

const uploadedFileApi = new UploadedFileApi(API_CONFIG);

export class UploadFailed extends Error {}

/**
 * Puts a source file in our bucket and returns its id, ready to attach.
 *
 * Same three steps as src/helpers/editorTest.ts — create the record, PUT the
 * bytes, mark it uploaded — but without the redux round trip, and private
 * rather than public: these are the customer's internal documents, and the only
 * things that should ever read them are the partner's pipeline and the people
 * who uploaded them.
 */
export async function uploadFile(file: File): Promise<string> {
  const record = await uploadedFileApi.uploadedFilesPost({
    body: {
      file_name: file.name,
      mime_type: file.type || 'application/octet-stream',
      size: file.size,
      is_public: false,
      is_uploaded: false,
    },
  });

  if (!record.upload_url) {
    throw new UploadFailed('no upload url was issued');
  }

  const response = await fetch(
    new Request(record.upload_url, {
      method: 'PUT',
      headers: {
        'Content-type': file.type || 'application/octet-stream',
      },
      body: file,
    })
  );

  if (!response.ok) {
    throw new UploadFailed(`bucket rejected the upload (${response.status})`);
  }

  // Only now does the record describe bytes that exist; attaching checks this.
  await uploadedFileApi.uploadedFilesIdPut({
    id: record.id,
    body: { ...record, is_uploaded: true } as any,
  });

  return record.id;
}
